import React, { PropTypes } from 'react';
import { IntlProvider } from 'react-intl';
import moment from 'moment';
import { connect } from 'react-redux';

import AnalyticsActions from '../actions/AnalyticsActions';
import AuthActions from '../actions/AuthActions';
import LibraryActions from '../actions/LibraryActions';

import BcReactComponent from '@bibliocommons/base-bc-react-component';
import { mapLocaleForMoment } from '@bibliocommons/utils-localization';

function mapStateToProps(state) {
  return {
    localization: state.get('localization').toJS(),
    coreCdnHost: state.getIn(['app', 'coreAssets', 'cdnHost']),
    mobileApp: state.getIn(['app', 'mobileApp'], false)
  };
}

class BCAppContainer extends BcReactComponent {
  constructor(props) {
    super(props);
    moment.locale(mapLocaleForMoment(props.localization.currentLanguage));
  }

  static fetchInitialData(params, query, store) {
    return [
      store.dispatch(AnalyticsActions.fetchDataLayer()),
      store.dispatch(LibraryActions.getLibrary()),
      store.dispatch(AuthActions.loadUser())
    ];
  }

  getChildContext() {
    return {
      coreCdnHost: this.props.coreCdnHost,
      mobileApp: this.props.mobileApp
    };
  }

  render() {
    const { children, localization } = this.props;

    return (
      <IntlProvider
        messages={localization.messages}
        locale={localization.currentLanguage}>
        {children}
      </IntlProvider>
    );
  }
}

BCAppContainer.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]),
  localization: PropTypes.shape({
    messages: PropTypes.objectOf(PropTypes.string),
    currentLanguage: PropTypes.string
  }),
  coreCdnHost: PropTypes.string.isRequired
};

BCAppContainer.childContextTypes = {
  coreCdnHost: PropTypes.string,
  mobileApp: PropTypes.bool
};

export default connect(mapStateToProps)(BCAppContainer);



// WEBPACK FOOTER //
// ./app/containers/BCAppContainer.jsx